export default "__VITE_ASSET__BD3vfxyh__"